import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostVouchersSubvoucherBody } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const postVouchersSubvoucher = createAsyncThunk<
  void,
  PostVouchersSubvoucherBody
>("vouchers/postVouchersSubvoucher", async (body, { rejectWithValue }) => {
  try {
    await VouchersAPI.postVouchersSubvoucher(body);
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while creating vouchers subvoucher",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while creating vouchers subvoucher", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
